/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
import Swiper from 'swiper';
import {
    Navigation, Pagination, Autoplay, Keyboard, A11y,
} from 'swiper/modules';

if (document.querySelector('.swiper-banner-js') && !document.querySelector('.swiper-banner-js.no-slider')) {
    const siteLanguage = document.querySelector('html').getAttribute('lang');
    const translations = {
        en: {
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            paginationBulletMessage: 'Go to slide {{index}}',
        },
        fr: {
            prevSlideMessage: 'Diapositive précédente',
            nextSlideMessage: 'Diapositive suivante',
            paginationBulletMessage: 'Aller à la diapositive {{index}}',
        },
    };

    const swiperAutoplay = document.querySelector('.swiper-autoplay-buttons');
    const autoplayPause = document.querySelector('.swiper-autoplay-pause');
    const autoplayPlay = document.querySelector('.swiper-autoplay-play');
    const swiperBannerElement = document.querySelector('.swiper-banner-js');
    const swiperBanner = new Swiper('.swiper-banner-js', {
        modules: [Pagination, Navigation, Autoplay, Keyboard, A11y],
        a11y: {
            enabled: true,
            prevSlideMessage: `${translations[siteLanguage].prevSlideMessage}`,
            nextSlideMessage: `${translations[siteLanguage].nextSlideMessage}`,
            paginationBulletMessage: `${translations[siteLanguage].paginationBulletMessage}`,
        },
        slidesPerView: 1,
        loop: true,
        keyboard: {
            enabled: true,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: swiperBannerElement.querySelector('.slider-button-next'),
            prevEl: swiperBannerElement.querySelector('.slider-button-prev'),
        },
        autoplay: {
            delay: 4000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
        },
        on: {
            lock() {
                autoplayPause.classList.add('lock');
                autoplayPlay.classList.add('lock');
            },
            unlock() {
                autoplayPause.classList.remove('lock');
                autoplayPlay.classList.remove('lock');
            },
        },
    });
    if (autoplayPause) {
        autoplayPause.addEventListener('click', () => {
            swiperAutoplay.classList.add('paused');
            swiperBanner.autoplay.pause();
        });
    }
    if (autoplayPlay) {
        autoplayPlay.addEventListener('click', () => {
            swiperAutoplay.classList.remove('paused');
            swiperBanner.autoplay.resume();
        });
    }
}
